
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 2.667A2.336 2.336 0 002.667 5 2.336 2.336 0 005 7.333 2.336 2.336 0 007.333 5 2.336 2.336 0 005 2.667zM5 6c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm6 2.667A2.336 2.336 0 008.667 11 2.336 2.336 0 0011 13.333 2.336 2.336 0 0013.333 11 2.336 2.336 0 0011 8.667zM11 12c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm-7.393 1.333l-.94-.94 9.726-9.726.94.94-9.726 9.726z","fill":"currentColor"}})])
          )
        }
      }
    